import { render, staticRenderFns } from "./BranchDetailModal.vue?vue&type=template&id=4b0885d6&"
import script from "./BranchDetailModal.js?vue&type=script&lang=js&"
export * from "./BranchDetailModal.js?vue&type=script&lang=js&"
import style0 from "./BranchDetailModal.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports